// extracted by mini-css-extract-plugin
module.exports = {"propertySize":"PropertySize_propertySize__1EuLi","selected":"PropertySize_selected__2VnzA"};